<template>
  <ValidationProvider
    :mode="mode"
    v-slot="{ errors }"
    :vid="vid"
    :name="name"
    :rules="rules"
    tag="div"
    ref="provider"
    :custom-messages="customMessages"
  >
    <AGCLabel v-if="label" :required="required" :id="id">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel"><span v-html="subLabel"></span></slot>
      </template>
    </AGCLabel>
      <b-form-group>
        <b-input-group :prepend="prepend">
          <b-form-input
            v-model="inputVal"
            :id="id"
            :type="type"
            :step="step"
            :state="state(errors)"
            :placeholder="placeholder"
            :disabled="disabled"
            :min="min"
            :max="max"
            :autofocus="autofocus"
          ></b-form-input>
        </b-input-group>
        <slot name="invalidFeedback" :errors="errors">
          <b-form-invalid-feedback :state="state(errors)">
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </slot>
      </b-form-group>
  </ValidationProvider>
</template>

<script>
import {
  BFormGroup, BFormInput, BFormInvalidFeedback, BInputGroup,
} from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin],
  components: {
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormInvalidFeedback,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    step: {
      type: String,
    },
    prepend: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-input,
.custom-limit {
  & .form-group {
    margin-bottom: 0;
  }

  & .d-block {
    float: left;
    display: inline-block;
  }
}
</style>
